import { useRef, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

const SimpleTypeahead = (props: any) => {
  const {
    id,
    placeholder,
    options,
    selected,
    onChange,
    multiple = false,
  } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      {multiple ? (
        <Typeahead
          open={isOpen}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setIsOpen(false)}
          className="c-agreement-box__filter"
          id={id}
          placeholder={placeholder}
          options={options}
          selected={selected}
          onChange={onChange}
          multiple
          positionFixed
        />
      ) : (
        <Typeahead
          open={isOpen}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setIsOpen(false)}
          id={id}
          placeholder={placeholder}
          options={options}
          selected={selected}
          onChange={onChange}
          positionFixed
        />
      )}
    </>
  );
};

export default SimpleTypeahead;
